import styled from 'styled-components';

// import { CustomZoomControl } from './CustomZoomControl';
import { MyLocationControl } from './MyLocationControl';
import { UniLocationControl } from './UniLocationControl';

import Box from '../../../Atomics/Box';

const ControlsWrapper = styled(Box)`
    position: absolute;
    bottom: 8px;
    right: 8px;
    z-index: 1000;
    pointer-events: none;
    cursor: grab;
`;

const StyledWrapper = styled(Box)`
    display: flex;
    flex-direction: column;
    background-clip: padding-box;
    filter: drop-shadow(0px 2px 8px rgba(0, 0, 0, 0.15));
    position: relative;
    z-index: 800;
    cursor: auto;
    pointer-events: auto;
    clear: both;
`;

export const MapControls = () => {
    return (
        <ControlsWrapper>
            <StyledWrapper>
                <UniLocationControl />
                <MyLocationControl />
                {/* <CustomZoomControl /> */}
            </StyledWrapper>
        </ControlsWrapper>
    );
};
